export default "__VITE_ASSET__BeLnNGTr__"